import React from 'react';
import styled from 'styled-components'

const GridContainerStyled = styled.div`
  width: 100%;
  max-width: ${props => props.fullWidth ? 'none' : +props.containerWidth + +props.gutterWidth + 'px'};
  margin: 0 auto;
  display: block;
  text-align: ${props => props.textAlign};
  ${props => props.colorBg ? 'background-color: ' + props.colorBg + ';' : ''}
  ${props => props.colorText ? 'color: ' + props.colorText + ';' : ''}
  @media(min-width: 812px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    >h1, >h2, >h3, >h4, >h5, >h6 {
      flex-basis: 100%;
    }
  }
  >* {
    padding: 0 ${props => props.gutterWidth / 2}px;
  }
`;

export class GridContainer extends React.Component {
  render() {
    let containerWidth = this.props.containerWidth || 1100,
      fullWidth = this.props.fullWidth,
      gutterWidth = this.props.gutterWidth || 30,
      textAlign = this.props.textAlign || 'left',
      colorBg = this.props.colorBg,
      colorText = this.props.colorText;
    return (
      <GridContainerStyled containerWidth={containerWidth} gutterWidth={gutterWidth} textAlign={textAlign} fullWidth={fullWidth} colorBg={colorBg} colorText={colorText}>
        {this.props.children}
      </GridContainerStyled>
    );
  }
}

const GridItemStyled = styled.div`
  display: block;
  text-align: ${props => props.textAlign};
  ${props => props.colorBg ? 'background-color: ' + props.colorBg + ';' : ''}
  ${props => props.colorText ? 'color: ' + props.colorText + ';' : ''}
  @media(min-width: 812px) {
    flex-basis: ${props => props.colWidth}%;
  }
`;

export class GridItem extends React.Component {

  render() {
    let colWidth = this.props.colWidth || 100,
      textAlign = this.props.textAlign || 'left',
      colorBg = this.props.colorBg,
      colorText = this.props.colorText;
    return (
      <GridItemStyled colWidth={colWidth} textAlign={textAlign} colorBg={colorBg} colorText={colorText}>
        {this.props.children}
      </GridItemStyled>
    );
  }
}
